import React from 'react';
import { useEffect } from "react";

const useDfpSlot = ({ path, size, id, pathname }) => {
    useEffect(() => {
      const googletag = window.googletag || {};
      googletag.cmd = googletag.cmd || [];
      googletag.cmd.push(function() {
        googletag.defineSlot(path, size, id)
          .addService(googletag.pubads());
        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs();
        googletag.enableServices();
      });
      googletag.cmd.push(function() {
        googletag.display(id);
      });
    }, [path, size, id, pathname]);
  };
  export default useDfpSlot;